<template>
    <span>
        <v-navigation-drawer app v-model="drawer" class="green" dark disable-resize-watcher>
            <v-list-item :to="{name: 'Home'}" style="text-decoration: none; color: white;">
                <v-list-item-title>
                    {{ $t('app.title') }}
                </v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>

            <v-list dense nav>
                <v-list-item link v-for="(navItem, idx) in navigationItems" :key="idx" :to="{name: navItem.link}" v-show="showNavItem(navItem, userProfile)">
                    <v-list-item-content>
                        <v-list-item-title>{{navItem.text}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <div class="px-4 py-12">
                <v-btn block :to="{name: 'SignIn'}" v-if="!authenticated">
                    <v-icon>mdi-login</v-icon>{{ $t('app.signIn') }}
                </v-btn>
                <v-btn block @click="onSignOut" v-if="authenticated">
                    <v-icon>mdi-logout</v-icon>{{ $t('app.signOut') }}
                </v-btn>
            </div>
        </v-navigation-drawer>

        <v-app-bar app color="green" dark>
            <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-app-bar-nav-icon>

            <router-link :to="{name: 'Home'}">
                <v-img src="@/assets/logo.png" height="40" width="40"></v-img>
            </router-link>

            <router-link :to="{name: 'Home'}" style="text-decoration: none; color: white;">
                <v-toolbar-title class="hidden-sm-and-down font-weight-bold text-uppercase px-3" data-cy="titleBtn">{{ $t('app.title') }}</v-toolbar-title>
            </router-link>

            <v-btn text class="hidden-sm-and-down" :to="{name: navItem.link}" v-for="(navItem, idx) in navigationItems" :key="idx" v-show="showNavItem(navItem, userProfile)">{{navItem.text}}</v-btn>

            <v-spacer></v-spacer>
            <small style="margin-right:10px">{{userProfile.email}}</small>
            <v-btn class="hidden-sm-and-down" :to="{name: 'SignIn'}" v-if="!authenticated">
                <v-icon>mdi-login</v-icon>{{ $t('app.signIn') }}
            </v-btn>
            <v-btn class="hidden-sm-and-down" @click="onSignOut" v-if="authenticated">
                <v-icon>mdi-logout</v-icon>{{ $t('app.signOut') }}
            </v-btn>

            <img src="@/assets/eler.jpg" style="max-width: 100%; height:100%; padding-left: 5px">

        </v-app-bar>
    </span>
</template>

<script>
    import {Roles} from '../_helpers/roles';

    export default {
        name: 'NavBar',
        data() {
            return {
                drawer: false,
                navigationItems: [
                    {text: this.$t('nav.plants'), link: 'Plants', roles: []},
                    {text: this.$t('nav.surveys'), link: 'Surveys', roles: [Roles.ROLE_3.value, Roles.ROLE_2.value, Roles.ROLE_1.value]},
                    {text: this.$t('nav.users'), link: 'Users', roles: [Roles.ROLE_2.value, Roles.ROLE_1.value]},
                    {text: this.$t('nav.report'), link: 'Report', roles: [Roles.ROLE_3.value, Roles.ROLE_2.value, Roles.ROLE_1.value]},
                    {text: this.$t('nav.imprint'), link: 'Imprint', roles: [/*Roles.USER*/]},
                ]
            };
        },
        computed: {
            authenticated() {
                return this.$store.getters.isAuthenticated;
            },
            userProfile() {
                return this.$store.state.user.userProfile
            }
        },
        methods: {
            onSignOut() {
                this.$store.dispatch('signOut');
            },
            showNavItem(navItem, userProfile) {
                if (navItem.roles.length <= 0) {
                    // Show public accessible nav-items
                    return true
                } else if (navItem.roles.length > 0 && userProfile && userProfile.role) {
                    // Show protected nav-items depending on authentication & role
                    return (this.authenticated && navItem.roles.includes(userProfile.role))
                } else {
                    return false
                }
            }
        }
    };
</script>

<style scoped>

</style>
